/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    IdentityProviderSettingsListConfiguration,
    IdentityProviderSettingsListConfigurationFromJSON,
    IdentityProviderSettingsListConfigurationToJSON,
    IdentityProviderSettingsListItemPaginationWrapper,
    IdentityProviderSettingsListItemPaginationWrapperFromJSON,
    IdentityProviderSettingsListItemPaginationWrapperToJSON,
    IdentityProviderSettingsListQuery,
    IdentityProviderSettingsListQueryFromJSON,
    IdentityProviderSettingsListQueryToJSON,
    IdentityProviderSettingsState,
    IdentityProviderSettingsStateFromJSON,
    IdentityProviderSettingsStateToJSON,
    IdentityProviderSettingsStateResponse,
    IdentityProviderSettingsStateResponseFromJSON,
    IdentityProviderSettingsStateResponseToJSON,
} from '../models';

export interface ApiIdentityProviderSettingsIdentityProviderSettingsListDataPostRequest {
    identityProviderSettingsListQuery?: IdentityProviderSettingsListQuery;
}

export interface ApiIdentityProviderSettingsIdentityProviderSettingsListUpdateStateBulkPostRequest {
    identityProviderSettingsState: Array<IdentityProviderSettingsState>;
}

/**
 * no description
 */
export class IdentityProviderSettingsListApi extends runtime.BaseAPI {

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsListConfigurationGetRaw(): Promise<runtime.ApiResponse<IdentityProviderSettingsListConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentityProviderSettings/IdentityProviderSettingsList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityProviderSettingsListConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsListConfigurationGet(): Promise<IdentityProviderSettingsListConfiguration> {
        const response = await this.apiIdentityProviderSettingsIdentityProviderSettingsListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsListDataPostRaw(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsListDataPostRequest): Promise<runtime.ApiResponse<IdentityProviderSettingsListItemPaginationWrapper>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentityProviderSettings/IdentityProviderSettingsList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentityProviderSettingsListQueryToJSON(requestParameters.identityProviderSettingsListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityProviderSettingsListItemPaginationWrapperFromJSON(jsonValue));
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsListDataPost(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsListDataPostRequest): Promise<IdentityProviderSettingsListItemPaginationWrapper> {
        const response = await this.apiIdentityProviderSettingsIdentityProviderSettingsListDataPostRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsListUpdateStateBulkPostRaw(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsListUpdateStateBulkPostRequest): Promise<runtime.ApiResponse<Array<IdentityProviderSettingsStateResponse>>> {
        if (requestParameters.identityProviderSettingsState === null || requestParameters.identityProviderSettingsState === undefined) {
            throw new runtime.RequiredError('identityProviderSettingsState','Required parameter requestParameters.identityProviderSettingsState was null or undefined when calling apiIdentityProviderSettingsIdentityProviderSettingsListUpdateStateBulkPost.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/IdentityProviderSettings/IdentityProviderSettingsList/UpdateStateBulk`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.identityProviderSettingsState.map(IdentityProviderSettingsStateToJSON),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(IdentityProviderSettingsStateResponseFromJSON));
    }

    /**
     */
    async apiIdentityProviderSettingsIdentityProviderSettingsListUpdateStateBulkPost(requestParameters: ApiIdentityProviderSettingsIdentityProviderSettingsListUpdateStateBulkPostRequest): Promise<Array<IdentityProviderSettingsStateResponse>> {
        const response = await this.apiIdentityProviderSettingsIdentityProviderSettingsListUpdateStateBulkPostRaw(requestParameters);
        return await response.value();
    }

}
